import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, Group, IValueViewModel } from '../../../models';
import { StoreService } from '../../../services';
import { StoreElement } from '../../../stateManagement';

class IdentifierAnalysisStateController implements angular.IComponentController {
    guid: string;
    isLoading: boolean;
    loadingMessage: string;
    selectedItem: any;
    viewModels: { [guid: string]: IValueViewModel };
    
    readonly selectedGroup: Group;

    static $inject = [
        '$scope',
        '$stateParams',
        'storeService',
    ];
    constructor(private _$scope: angular.IScope,
        private _$stateParams: angular.ui.IStateParamsService,
        private _storeService: StoreService) {
    }

    $onInit() {
        this._$scope.$watch(() => this.selectedItem, () => {
            if (this.selectedItem) {
                this.guid = this.selectedItem.guid;
            }
        });
        if (this.selectedGroup && this.selectedGroup.identifierCollection.length > 0 && !this.selectedItem) {
            if (this._$stateParams['identifierGuid']) {
                this.selectedItem = _.find(this.selectedGroup.identifierCollection, i => i.guid === this._$stateParams['identifierGuid']);
            } else {
                this.selectedItem = _.sortBy(this.selectedGroup.identifierCollection, ['sortingOrder', 'name'])[0];
            }
        }
        this._storeService.register(store => {
            this.viewModels = store.valueViewModels.dictionary;
        }, [StoreElement.ValueViewModels]);
    }
}

export const wtIdentifierAnalysisState: ComponentDefinition = {
    componentId: 'wtIdentifierAnalysisState',
    controller: IdentifierAnalysisStateController,
    template: require('./identifierAnalysisState.component.html'),
    controllerAs: 'vm',
    bindings: {
        selectedGroup: '<'
    }
};
